/**
 * Which plans unlock paid capabilities.
 *
 * Mirrors `backend/accounts/plan_constants.py` — keep the two in step. The
 * `PlanEnum` in types/user.ts predates the V2 rollout and only ever matched
 * "free" correctly, so it can't be used for gating.
 *
 * Read this against the ACTIVE WORKSPACE's billing account, never the viewer's
 * own `user.plan`. The backend already works that way — workbench and sources
 * gate on `WorkspaceHasAccess`, i.e. membership — so a member of a paid
 * workspace is served the data. Their personal plan stays "free" forever, and
 * gating the UI on it showed them a paywall over content they can access.
 */
const LEGACY_PAID_PLANS = [
  "standard_monthly",
  "standard_yearly",
  "premium_monthly",
  "premium_yearly",
  "personalized",
];

const V2_PLANS = ["v2_monthly", "v2_annual"];

const PAID_PLANS = new Set([...LEGACY_PAID_PLANS, ...V2_PLANS]);

export const isPaidPlan = (plan: string | null | undefined): boolean =>
  plan != null && PAID_PLANS.has(plan);
